import classNames from 'classnames'
import React from 'react'
import { twMerge } from 'tailwind-merge'

export type DividerProps = {
  textPosition?: 'left' | 'center' | 'right' | 'between'
  text?: string
  title?: boolean
  className?: string
  /** Deprecated, use 'labelClasses' */
  textClasses?: string
  children?: React.ReactNode
  variant?: 'line' | 'bar'
  labelClasses?: string
  labelContainerClasses?: string
  bgColor?: string
  loading?: boolean
  forceFullWidth?: boolean
}

export const Divider = (props: DividerProps) => {
  const variant = props.variant || 'bar'

  const labelClasses = twMerge(
    'px-2 bg-inherit text-base-500 text-sm justify-start',
    props.title && 'text-lg font-medium text-base-900',
    props.textClasses,
  )

  const labelContainerClasses = twMerge(
    'relative flex justify-start items-center',
    classNames({
      'justify-center': props.textPosition === 'center',
      'justify-end': props.textPosition === 'right',
      'justify-between': props.textPosition === 'between',
    }),
  )

  const bgColor = props.bgColor || 'bg-gray-100 dark:bg-gray-600/50'
  if (variant === 'bar')
    return (
      <React.Fragment>
        <div
          className={twMerge(
            'text-sm leading-6 text-base-900 relative',
            props.forceFullWidth &&
              'absolute z-[1000] w-screen left-0 right-0 px-2',
            props.className,
          )}>
          <div
            className={twMerge(
              'relative isolate py-2 font-semibold',
              props.labelClasses,
            )}>
            {props.loading ? (
              <p className='w-[200px] bg-slate-200 animate-pulse rounded-sm text-gray-100 dark:text-base-600/50'>
                '
              </p>
            ) : (
              props.text
            )}
            <div
              className={`absolute inset-y-0 right-full -z-10 w-full border-b border-gray-200 dark:border-base-200 ${bgColor}`}
            />
            <div
              className={`absolute inset-y-0 left-0 -z-10 w-full border-b border-gray-200 dark:border-base-200 ${bgColor}`}
            />
          </div>

          {props.children && (
            <th className='relative isolate w-full text-left py-2 font-semibold'>
              {props.children}
            </th>
          )}
        </div>
        {props.forceFullWidth && <div className='w-0.5 h-[30px]' />}
      </React.Fragment>
    )

  const containerClasses = twMerge('relative w-full', props.className)
  return (
    <div className={containerClasses}>
      <div className='absolute inset-0 flex items-center' aria-hidden='true'>
        <div className='w-full border-t border-gray-300' />
      </div>
      <div className={labelContainerClasses}>
        <span className={labelClasses}>{props.text || ''}</span>
        <span className='bg-base-0'>{props.children}</span>
      </div>
    </div>
  )
}
